import {ActiveRecord} from './ActiveRecord';
import config from 'config'
import {CmsEditorState} from "./club-cms";
import {grabImages} from "./club-cms/image-graber";
import {ListItemImage} from "./club-cms/content/list.content";
import {BaseListImage} from "./club-cms/content/base.content";
import {ImageListItemImage} from "./club-cms/content/image-list.content";
import {GalleryContentItem} from "./club-cms/content/gallery.content";
import {StreamProvider} from "./stream/index";

export interface ClubDTO {
  id: string;
  name: string;
  time_zone: string;
  info: any[];
  stream_provider: string;
}

const LIST_ITEM_REF = 'team-member';
const IMAGE_LIST_ITEM_REF = 'studious';
const GALLERY_ITEM_REF = 'gallery';

class Club extends ActiveRecord {
  name: string;
  info: any[];
  streamProvider: StreamProvider;

  static path = `${config.backOfficeBasePath}/clubs`;

  static parseData(data: ClubDTO) {
    let res = new Club({});
    return Object.assign(res, res._parseData(data));
  }

  _parseData(data: ClubDTO) {
    return {
      id: data.id,
      name: data.name,
      streamProvider: data.stream_provider === 'custom' ? StreamProvider.custom : StreamProvider.livestream,
      info: data.info
      // published: data.published,
      // content: data.content,
      // image: data.image_url
      //   ? new FanBoxMessagesImage(Object.assign(new FanBoxMessagesImageDTO(), data.image_url))
      //   : null,
      // createDate: new Date(data.created_at),
      // publishDate: data.publish_date ? new Date(data.publish_date) : null
    };
  }

  _getModel() {
    return Club;
  }

  async saveImages(info: CmsEditorState) {
    let newImages = grabImages(info.items.toArray());
    let listImages = newImages.filter(item => item instanceof ListItemImage);
    let imageListImages = newImages.filter(item => item instanceof ImageListItemImage);
    let galleryImages = newImages.filter(item => item instanceof GalleryContentItem);

    let saveImagePromise  = Promise.all([
      this.saveModels(listImages, LIST_ITEM_REF),
      this.saveModels(imageListImages, IMAGE_LIST_ITEM_REF),
      this.saveModels(galleryImages, GALLERY_ITEM_REF)
    ]);

    return await saveImagePromise;
  }

  async updateInfo(info: CmsEditorState) {
    return await this._networkLayer.patchJSON(this._prepareUrl(this.id), { info: info.toJSON() });
  }

  async saveModels(items: BaseListImage[], ref_data: string) {
    if (items.length > 0) {
      let requestData = {
        ref_data,
      };

      items.forEach((image, index) => requestData['file' + index] = image.file);


      let responses = await this._networkLayer.postFormData(this._prepareUrl(this.id) + '/photos', requestData);

      let data = await responses.json();

      items.forEach((item, index) => item.setOriginal(data[index]));

      return items;
    }
  }

}

export default Club;




// WEBPACK FOOTER //
// ./src/api/club.ts